module.exports = __webpack_public_path__ + "img/undraw_warning.01151a21.svg";